"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelCreateDTOSchema = exports.ChannelRequestDTOSchema = exports.ChannelDTO = exports.ChannelSchema = exports.ChannelBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var forumParticipants_1 = require("./lib/forumParticipants");
var utils_1 = require("./lib/utils");
var Post_1 = require("./Post");
exports.ChannelBaseSchema = zod_1.z.object({
    name: zod_1.z
        .string()
        .trim()
        .min(5, { message: 'The forum name is too short' })
        .max(25, { message: 'The forums name is too long' })
        .refine(utils_1.isStringHTMLValid, { message: 'The forum name is not valid' }),
    authRequired: zod_1.z.boolean().default(false),
    privacy: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    privacyTypeSlugs: zod_1.z.array(zod_1.z.string()).default([]),
    membersCanCreateTopics: zod_1.z.boolean().optional(),
    description: zod_1.z.string().optional(),
    order: zod_1.z.number(),
    posts: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
});
exports.ChannelSchema = exports.ChannelBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var ChannelDTOSchema = exports.ChannelSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.ChannelDTO = {
    convertFromModel: function (model) {
        var _a, _b;
        var posts = (0, ObjectId_1.isArrayPopulated)(model.posts)
            ? model.posts.map(function (post) { return Post_1.PostDTO.convertFromModel(post); })
            : (_a = model.posts) === null || _a === void 0 ? void 0 : _a.map(function (post) { return post.toString(); });
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            name: model.name,
            description: model.description,
            authRequired: model.authRequired,
            order: model.order,
            posts: posts,
            image: model.image,
            imagePublicId: model.imagePublicId,
            privacyTypeSlugs: (_b = model.privacyTypeSlugs) !== null && _b !== void 0 ? _b : [],
            membersCanCreateTopics: model.membersCanCreateTopics === true,
            participantCount: (0, ObjectId_1.isArrayPopulated)(model.posts) ? (0, forumParticipants_1.countUniqueParticipantsFromPosts)(posts) : 0,
        };
        return dto;
    },
};
exports.ChannelRequestDTOSchema = ChannelDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { posts: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid post id')) }));
exports.channelCreateDTOSchema = exports.ChannelBaseSchema.extend({
    privacyTypeSlugs: zod_1.z.array(zod_1.z.string().min(1)).optional().default([]),
}).omit({ posts: true, privacy: true });
//# sourceMappingURL=Channel.js.map